import * as xtractErrorActions from './xtractErrorActions'
import * as patientDisplay from './patientDisplayActions'
import * as multiContext from './multiContextActions.js'
import * as roomingConfig from './roomingConfigActions'
import * as interactable from './interactableActions'
import * as adminDisplay from './adminDisplayActions'
import * as authActions from './authActions'
import * as logActions from './logActions'
import * as notification from './notificationActions'
import * as lobbyConfig from './lobbyConfigActions'
import * as dashboard from './dashboardActions.js'
import * as lobbyLogin from './lobbyLoginActions'
import * as appConfig from './appConfigActions'
import * as encounter from './encounterActions'
import * as modalActions from './modalActions'
import * as clockActions from './clockActions'
import * as identity from './identityActions'
import * as apiActions from './apiActions'
import * as locks from './lockActions'
const rootActions = {
  // ...windowMessaging, this should only be explicitly imported in withMessaging HOC
  ...xtractErrorActions,
  ...patientDisplay,
  ...roomingConfig,
  ...clockActions,
  ...interactable,
  ...notification,
  ...adminDisplay,
  ...modalActions,
  ...multiContext,
  ...lobbyConfig,
  ...authActions,
  ...apiActions,
  ...lobbyLogin,
  ...logActions,
  ...dashboard,
  ...encounter,
  ...appConfig,
  ...identity,
  ...locks
}

export default rootActions
